<template>
    <div class="ListingTrainDistance">
        <div class="row">
            <div class="col-xs-12 col-sm-6">
                <h5><strong>{{'Nearby Train Stations' | language}}</strong></h5>
                <div class="TrainStation" v-for="station of building.stations" :key="station.int_station_id">
                    <span><strong><i class="fas fa-subway"></i>{{ language ==='english' ? station.str_station_name_en : station.str_station_name_jp}}</strong></span>
                    <span class="ListingTrainDistance__Station" v-for="line of station.train_lines" :key="line.int_train_line_id" ><small><i class="fas fa-minus" :style="{color:line.color}"></i>{{ language ==='english' ? line.str_train_line_name_en : line.str_train_line_name_jp}}</small></span>
                    <small><i class="fas fa-walking"></i>{{station.pivot.int_distance}} minutes</small>
                </div>
                <span><small v-if="building.stations && building.stations.length === 0">{{'Not Found' | language}}</small></span>
            </div>
            <div class="col-xs-12 col-sm-6">
                <h5><strong>{{'Nearby Schools' | language}}</strong></h5>
                <div v-for="school of building.schools" :key="school.int_school_id">
                    <span><strong><i class="fas fa-school"></i>{{ language === 'english' ? school.str_school_name_en : school.str_school_name_jp}}</strong></span>
                </div>
                <span><small v-if="building.schools && building.schools.length === 0">{{'Not Found' | language}}</small></span>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    export default {
        name: 'listing-train-distance',
        data() {
            return {
                defaultStationNumber: 3
            }
        },
        computed: {
        ...mapState({
            language: (state) => {
                return state.general.language
            }
        })
        },
        props: {
            building: Object
        },
        created() {
        }
    }
</script>

<style lang="scss">
    .ListingTrainDistance {
        display: inline-block;
        width: 100%;
        border: $borders;
        border-radius: $border-radius;
        margin-top: 1.5em;

        span {
            display: table;
        }

        .fas {
            width: 30px;
        }

        .fa-walking {
            padding-left: .2rem;
            padding-right: 1.25rem
        }

        .TrainStation {
            margin-bottom: 1em;
        }
    }

    @media only screen and (max-width: 600px) {
        .ListingTrainDistance {
            position: relative;
            box-shadow: none;
            top: 0;
            left: 0;
            width: 100%;
            border: 0;
            padding: auto;
        }
    }
</style>


